import React from 'react';
import { Body } from './Body';
import { Header } from './Header';

export const Calendar = () => (
  <div className="calendar">
    <Header />
    <Body />
  </div>
);
